(() => {
  "use strict";
  const bar = document.querySelector("[data-elookus-mobile-purchase-bar]");
  if (!bar || bar.dataset.initialized === "true") return;
  bar.dataset.initialized = "true";
  const html = document.documentElement;
  const mobile = window.matchMedia("(max-width: 767px)");
  const status = bar.querySelector("[data-elookus-mobile-purchase-status]");
  const buttons = Array.from(bar.querySelectorAll("[data-elookus-mobile-purchase]"));
  const sourceSelectors = { frame: "[data-elv2-frame-only]", lenses: "[data-elv2-start-lenses]" };
  const overlaySelector = 'dialog[open],modal-dialog[open],side-drawer[open],cart-drawer[open],.drawer[open],.modal[open],[role="dialog"],[role="alertdialog"],[aria-modal="true"],.js-overlay.is-visible,.elv2-overlay:not([hidden]),[data-elv2-cart-layer]:not([hidden])';
  let frame = 0;
  let lastActivation = 0;
  let previewOffset = 0;
  let previewWrapper = null;
  let managedEntry = null;
  const previewResize = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function context() {
    const form = document.querySelector('form.js-product-form[data-product-id="' + bar.dataset.productId + '"]');
    const scope = form?.closest("product-form");
    const entry = scope?.querySelector(".elv2-entry:not([data-elv2-server-entry])");
    return { scope, entry };
  }

  function visible(element) {
    if (!element || element.closest('[hidden],[aria-hidden="true"]')) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== "none" && !["hidden", "collapse"].includes(style.visibility) && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function sourceControlsReady(entry) {
    return Object.values(sourceSelectors).every((selector) => entry?.querySelector(selector)?.isConnected);
  }

  function keyboardOpen() {
    const active = document.activeElement;
    const editing = active?.matches('textarea,select,input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]),[contenteditable="true"]');
    const viewport = window.visualViewport;
    return Boolean(editing && viewport && window.innerHeight - viewport.height > 120);
  }

  function overlayOpen() {
    if (html.matches(".elv2-page-locked,.elookus-tryon-open")) return true;
    if (document.body.matches(".enable-mobile-nav-transition,.reveal-mobile-nav,.show-search")) return true;
    return Array.from(document.querySelectorAll(overlaySelector)).some(visible);
  }

  function busy(scope) {
    return Boolean(scope?.querySelector('[data-elv2-cart-feedback][data-state="pending"],button[name="add"].is-loading,button[name="add"][aria-busy="true"]'));
  }

  function syncPreviewToolbar() {
    // Shopify's preview toolbar is in the top layer and can cover fixed controls.
    // Only reserve its actual visible height; normal storefronts have no wrapper.
    const wrapper = document.getElementById("PBarNextFrameWrapper");
    if (wrapper !== previewWrapper) {
      previewResize?.disconnect();
      previewWrapper = wrapper;
      if (wrapper) previewResize?.observe(wrapper);
    }
    previewOffset = visible(wrapper) ? Math.max(0, Math.ceil(window.innerHeight - wrapper.getBoundingClientRect().top)) : 0;
    const value = previewOffset + "px";
    if (html.style.getPropertyValue("--elookus-mobile-preview-offset") !== value) html.style.setProperty("--elookus-mobile-preview-offset", value);
    if (html.classList.contains("elookus-mobile-preview-toolbar") !== Boolean(previewOffset)) html.classList.toggle("elookus-mobile-preview-toolbar", Boolean(previewOffset));
  }

  function measure() {
    if (bar.hidden) return;
    const height = Math.ceil(bar.getBoundingClientRect().height);
    const value = height + previewOffset + "px";
    if (height && html.style.getPropertyValue("--elookus-mobile-purchase-height") !== value) html.style.setProperty("--elookus-mobile-purchase-height", value);
  }

  function sync() {
    frame = 0;
    syncPreviewToolbar();
    const { scope, entry } = context();
    const ready = html.classList.contains("elv2-lens-ready") && Boolean(entry);
    // The mobile bar is the single entry from the first screen, not a late scroll shortcut.
    const active = mobile.matches && ready && sourceControlsReady(entry);
    if (managedEntry && managedEntry !== entry) managedEntry.classList.remove("elookus-mobile-entry-owned");
    managedEntry = entry || null;
    if (entry && entry.classList.contains("elookus-mobile-entry-owned") !== active) entry.classList.toggle("elookus-mobile-entry-owned", active);
    if (html.classList.contains("elookus-mobile-purchase-active") !== active) html.classList.toggle("elookus-mobile-purchase-active", active);
    const show = active && !overlayOpen() && !keyboardOpen() && previewOffset < window.innerHeight / 2;
    if (bar.hidden === show) bar.hidden = !show;
    if (html.classList.contains("elookus-mobile-purchase-visible") !== show) html.classList.toggle("elookus-mobile-purchase-visible", show);
    const pending = html.classList.contains("elv2-variant-pending");
    const kind = pending ? "pending" : entry?.dataset.elookusStock || "pending";
    const inFlight = busy(scope);
    buttons.forEach((button) => {
      const original = entry?.querySelector(sourceSelectors[button.dataset.elookusMobilePurchase]);
      const disabled = !show || kind !== "available" || inFlight || !original || original.matches(":disabled") || original.getAttribute("aria-disabled") === "true";
      if (button.disabled !== disabled) button.disabled = disabled;
    });
    const message = inFlight ? "Adding to cart…" : kind === "available" ? "" : kind === "soldout" ? "This color is sold out" : kind === "choose" ? "Choose a color" : "Updating selection…";
    if (status.textContent !== message) status.textContent = message;
    if (status.hidden !== !message) status.hidden = !message;
    measure();
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  bar.addEventListener("click", (event) => {
    const proxy = event.target.closest("[data-elookus-mobile-purchase]");
    if (!proxy || proxy.disabled || bar.hidden || !mobile.matches || overlayOpen()) return;
    event.preventDefault();
    const now = Date.now();
    if (now - lastActivation < 600 || html.classList.contains("elv2-variant-pending")) return;
    // Refresh availability synchronously so a fast color change cannot use a stale variant.
    if (!window.ElookusAvailability?.canPurchase()) { sync(); return; }
    const { scope, entry } = context();
    const original = entry?.querySelector(sourceSelectors[proxy.dataset.elookusMobilePurchase]);
    if (!html.classList.contains("elv2-lens-ready") || !original || !original.isConnected || original.matches(":disabled") || original.getAttribute("aria-disabled") === "true" || busy(scope)) { sync(); return; }
    lastActivation = now;
    // Only invoke the real, current entry control. Globo and the existing flow own all submission.
    original.click();
    if (proxy.dataset.elookusMobilePurchase === "frame") {
      window.requestAnimationFrame(() => {
        const confirmation = context().entry?.querySelector(".elv2-frame-confirm");
        if (!confirmation || confirmation.hidden || overlayOpen()) return;
        confirmation.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
        confirmation.querySelector("[data-elv2-frame-cart]")?.focus({ preventScroll: true });
      });
    }
    sync();
  });

  // Observe replacements and state changes, not cached buttons or copied listeners.
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => !bar.contains(mutation.target))) schedule();
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ["class", "style", "hidden", "disabled", "aria-disabled", "aria-hidden", "aria-modal", "aria-busy", "open", "data-elookus-stock", "data-state", "value"] });
  new MutationObserver(schedule).observe(html, { attributes: true, attributeFilter: ["class"] });
  ["elookus:lens-flow-v2-ready", "on:variant:change", "shopify:section:load", "shopify:section:unload", "change", "transitionend", "transitioncancel", "animationend"].forEach((name) => document.addEventListener(name, schedule));
  ["pageshow", "resize", "scroll"].forEach((name) => window.addEventListener(name, schedule, { passive: true }));
  document.addEventListener("toggle", schedule, true);
  document.addEventListener("focusin", schedule);
  document.addEventListener("focusout", schedule);
  window.visualViewport?.addEventListener("resize", schedule, { passive: true });
  window.visualViewport?.addEventListener("scroll", schedule, { passive: true });
  mobile.addEventListener("change", schedule);
  if (window.ResizeObserver) new ResizeObserver(measure).observe(bar);
  sync();
})();

